export default __webpack_public_path__ + "static/media/officeMap.8b19132d.png";